import React from "react";
import { Link } from "react-router-dom";
import PdfLoader from "../components/Pdf/PdfLoader";
import { Affiliation } from "../document";

const RecognitionAffiliation = () => {
  return (
    <>
      <div className="breadcrumb-area d-flex  p-relative align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>Recognition & Affiliation</h2>
                </div>
              </div>
            </div>
            <div className="breadcrumb-wrap2">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  Recognition & Affiliation
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="prospectus-structure">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-10">
              <PdfLoader pdfUrl={Affiliation} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecognitionAffiliation;
